module.exports = __webpack_public_path__ + "static/media/37-5.f6a5d57d.mp3";